import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllNarrators,
  createNewNarrator,
  editNarrator,
  deleteNarrator,
  getNarratorsAsDataTable,
  getNarratorsLookUps,
  getDefaultNarrator,
  createNarratorMultilingual,
  editNarratorMultilingual,
  getNarratorByIdMultilingual,
} from './thunks';
import { NarratorsState } from './types';

export const name = 'narrators';

const initialState: NarratorsState = {
  data: [],
  dataTableData: null,
  lookups: [],
  status: 'idle',
  updatingStatus: 'idle',
  datatableStatus: 'idle',
  lookupsStatus: 'idle',
  createMultilingual: {
    data: null,
    status: 'idle',
  },
  editMultilingual: {
    data: null,
    status: 'idle',
  },
  byIdMultilingual: {
    data: null,
    status: 'idle',
  },
};

export const getAllNarratorsAsync = createAsyncThunk(
  name + '/getAllNarrators',
  getAllNarrators
);
export const createNewNarratorAsync = createAsyncThunk(
  name + '/createNewNarrator',
  createNewNarrator
);
export const editNarratorAsync = createAsyncThunk(
  name + '/editNarrator',
  editNarrator
);

export const deleteNarratorAsync = createAsyncThunk(
  name + '/deleteNarrator',
  deleteNarrator
);
export const getNarratorsAsDataTableAsync = createAsyncThunk(
  name + '/getNarratorsAsDataTable',
  getNarratorsAsDataTable
);
export const getNarratorsLookUpsAsync = createAsyncThunk(
  name + '/getNarratorsLookUps',
  getNarratorsLookUps
);
export const getDefaultNarratorAsync = createAsyncThunk(
  name + '/getDefaultNarrator',
  getDefaultNarrator
);

export const createNarratorMultilingualAsync = createAsyncThunk(
  name + '/createNarratorMultilingual',
  createNarratorMultilingual
);

export const editNarratorMultilingualAsync = createAsyncThunk(
  name + '/editNarratorMultilingual',
  editNarratorMultilingual
);

export const getNarratorByIdMultilingualAsync = createAsyncThunk(
  name + '/getNarratorByIdMultilingual',
  getNarratorByIdMultilingual
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },

    clearLookups: (state) => {
      state.lookups = [];
    },
    clearDataTableData: (state) => {
      state.dataTableData = null;
    },
    clearByIdMultilingual: (state) => {
      state.byIdMultilingual = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllNarratorsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllNarratorsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllNarratorsAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getNarratorsAsDataTableAsync.pending, (state) => {
        state.datatableStatus = 'loading';
      })
      .addCase(getNarratorsAsDataTableAsync.fulfilled, (state, action) => {
        state.datatableStatus = 'idle';
        state.dataTableData = action.payload;
      })
      .addCase(getNarratorsAsDataTableAsync.rejected, (state) => {
        state.datatableStatus = 'failed';
      })
      .addCase(getNarratorsLookUpsAsync.pending, (state) => {
        state.lookupsStatus = 'loading';
      })
      .addCase(getNarratorsLookUpsAsync.fulfilled, (state, action) => {
        state.lookupsStatus = 'idle';
        state.lookups = action.payload;
      })
      .addCase(getNarratorsLookUpsAsync.rejected, (state) => {
        state.lookupsStatus = 'failed';
      })
      .addCase(createNewNarratorAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(createNewNarratorAsync.fulfilled, (state) => {
        state.updatingStatus = 'idle';
      })
      .addCase(createNewNarratorAsync.rejected, (state) => {
        state.updatingStatus = 'failed';
      })
      .addCase(editNarratorAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(editNarratorAsync.fulfilled, (state) => {
        state.updatingStatus = 'idle';
      })
      .addCase(editNarratorAsync.rejected, (state) => {
        state.updatingStatus = 'failed';
      })
      .addCase(deleteNarratorAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(deleteNarratorAsync.fulfilled, (state) => {
        state.updatingStatus = 'idle';
      })
      .addCase(deleteNarratorAsync.rejected, (state) => {
        state.updatingStatus = 'failed';
      })
      .addCase(createNarratorMultilingualAsync.pending, (state) => {
        state.createMultilingual.status = 'loading';
      })
      .addCase(createNarratorMultilingualAsync.fulfilled, (state, action) => {
        state.createMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createNarratorMultilingualAsync.rejected, (state) => {
        state.createMultilingual.status = 'failed';
      })
      .addCase(editNarratorMultilingualAsync.pending, (state) => {
        state.editMultilingual.status = 'loading';
      })
      .addCase(editNarratorMultilingualAsync.fulfilled, (state, action) => {
        state.editMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(editNarratorMultilingualAsync.rejected, (state) => {
        state.editMultilingual.status = 'failed';
      })
      .addCase(getNarratorByIdMultilingualAsync.pending, (state) => {
        state.byIdMultilingual.status = 'loading';
      })
      .addCase(getNarratorByIdMultilingualAsync.fulfilled, (state, action) => {
        state.byIdMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getNarratorByIdMultilingualAsync.rejected, (state) => {
        state.byIdMultilingual.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
